import React from "react";
import ReactDOM from "react-dom";

import "./styles/main.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createUploadLink } from "apollo-upload-client";

import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  ApolloProvider,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import UserDataReducer from "./common/UserDataReducer";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { getGuestTokens, getTokens } from "./auth";
import { BACKEND_URL } from "./constants/appUrl";

const apiURL = BACKEND_URL + "/graphql/";

const httpLink = createHttpLink({
  uri: apiURL,
});

const uploadLink = createUploadLink({
  uri: apiURL,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const pathName = window.location.pathname.split("/")[1];
  // Manage guest token
  if (pathName === "guest-login" || pathName === "guest-form-submission") {
    const guestTokens = getGuestTokens();
    return {
      headers: {
        ...headers,
        authorization: `JWT ${guestTokens ?? ""}`,
      },
    };
  }
  let jwt_token;
  const tokens = getTokens();
  if (tokens && tokens.JWT) {
    jwt_token = `JWT ${tokens.JWT}`;
  } else if (
    pathName !== "login" &&
    pathName !== "create-account" &&
    pathName !== "sign-up" &&
    pathName !== "reset-password" &&
    pathName !== "forgot-password"
  ) {
    // window.location.href = "/login";
  }
  return {
    headers: {
      ...headers,
      authorization: jwt_token,
    },
  };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache",
    },
  },
});

export const uploadClient = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache: new InMemoryCache(),
});
const store = createStore(UserDataReducer);

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <App />
      </Provider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
